function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("image", {
  width: 16,
  height: 11,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAABDklEQVQoU43SOygGYBTG8d+XkkJklTAZZbKRwcbAgEFupVwKg4FFLpHLwCQlMctgkcFCTMpkUEwykgWD5NKpd5K+z1nO8L7n3/Oc52RQjy68IF/u+kIBHnCcwRCaMY0q5OVgPKMWLdgJwACmUr/ILUAhtlCOtQC0Jxsf+MQcQuZf1YRB3CQbJwHoxysOsIJKjOLpF2EErUntNeZxGYAeFGEzDYSiWczgECXhFd/oxjsqMIbTvwDjqE6wSKUM9yjGOu7S+zDOAtCXPu8l/6UISNQyznGEBkwkZbdYiLcAdKb8I9saTGZJohG92EcdrgLQgUVsY/UfMcbhhZVHbASgLS1wF29podk4cUgxE33pB09dOP1iqO9rAAAAAElFTkSuQmCC"
})));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    color: "#FFFFFF",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.e75a72ed.svg";
export { ForwardRef as ReactComponent };